import * as Fmt$SolvuuApi0 from "solvuu-api0/./fmt.bs.js";
var Parse = Fmt$SolvuuApi0.Parse;
var Format_of = Fmt$SolvuuApi0.Format_of;
export { Parse, Format_of };
/* Fmt-SolvuuApi0 Not a pure module */